import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserInfoData } from 'api/types/types';
import { RootState } from 'store';

interface UserState {
  user: UserInfoData | null;
}

const initialState: UserState = {
  user: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state: UserState, action: PayloadAction<UserInfoData>) {
      state.user = action.payload;
    },
  },
});

export const { setUser } = userSlice.actions;
export const userSelector = (state: RootState): UserState => state.userInfo;
